import {Component, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {LocalStorageService} from 'src/app/local-storage.service';
import {MainDataModels} from 'src/app/models/maindata-models';
import {MainDataService} from 'src/app/services/main-data.service';
import {MessageBoxService} from 'src/app/services/message-box.service';
import {SwissSettingsService} from 'src/app/services/swiss-settings.service';
import {TerminEintragComponent} from '../pendenzen/termin-eintrag/termin-eintrag.component';
import {MeineTermineDetailViewComponent} from '../meine-termine-detail-view/meine-termine-detail-view.component';

export interface TerminEintrag {
    id: string;
}

@Component({
    selector: 'app-meine-termine',
    templateUrl: './meine-termine.component.html',
    styleUrls: ['./meine-termine.component.scss'],
})
export class MeineTermineComponent implements OnInit {
    public terminZeilen!: MainDataModels.TerminListenEintrag[];
    public innerWidth: any;
    private dbTermine?: MainDataModels.Termin[];
    private storageWebMain: string = 'SwissWebMainDB';
    private aktuelleUhrzeitStunden: number = 0;
    private aktuelleUhrzeitMinuten: number = 0;
    /* Termin bearbeiten */
    private dataForCalendarAppointment?: MainDataModels.TerminMitBenutzer;
    private currTerminMitBenutzern?: MainDataModels.TerminMitBenutzer;

    /* ENDE Termin bearbeiten */

    constructor(
        private svcMainData: MainDataService,
        private localStorageService: LocalStorageService,
        private svcMessageBox: MessageBoxService,
        public dialog: MatDialog,
        private swissSettings: SwissSettingsService,
    ) {
    }

    ngOnInit(): void {
        this.innerWidth = window.innerWidth;
        this.loadTermine();
    }

    async loadTermineFromIndexedDB(): Promise<boolean> {
        return this.localStorageService
            .get('termine', this.storageWebMain)
            .then((value) => {
                if (value === false) {
                    // Es konnte keinen Wert in der indexeddb für Objekte/Aufträge ermittelt werden
                    return false;
                } else {
                    // Die Aufträge konnten geladen werden
                    if (value) {
                        this.dbTermine = <MainDataModels.Termin[]> value;
                        this.loadListenTermine();
                    }
                    console.log('loadPendenzenFromIndexedDB - Ende');
                    return true;
                }
            });
    }

    loadListenTermine() {
        if (this.dbTermine) {
            this.terminZeilen = [];

            this.dbTermine.sort((a, b) => {
                const dateA = new Date(a.startDate!);
                const dateB = new Date(b.startDate!);
                const timeA = a.startTime?.split(':') || ['0', '0'];
                const timeB = b.startTime?.split(':') || ['0', '0'];

                dateA.setHours(Number(timeA[0]), Number(timeA[1]));
                dateA.setHours(Number(timeB[0]), Number(timeB[1]));

                if (dateA < dateB) {
                    return -1;
                }
                if (dateA > dateB) {
                    return 1;
                }
                return 0;
            }).forEach((t) => {
                let datumStartMitZeit: Date = new Date(t.startDate!);
                let time = t.startTime?.split(':') || [];
                if (time[0]) {
                    datumStartMitZeit.setHours(Number(time[0]));
                }
                if (time[1]) {
                    datumStartMitZeit.setMinutes(Number(time[1]));
                }

                let datumEndeMitZeit: Date = new Date(t.endDate!);
                time = t.endTime?.split(':') || [];
                if (time[0]) {
                    datumEndeMitZeit.setHours(Number(time[0]));
                }
                if (time[1]) {
                    datumEndeMitZeit.setMinutes(Number(time[1]));
                }

                this.terminZeilen!.push({
                    id: t.id,
                    objectID: t.objectID,
                    terminStart: datumStartMitZeit,
                    terminEnde: datumEndeMitZeit,
                    objDesc: t.description,
                    description: t.description,
                    location: t.location,
                    createdBy: t.createdBy,
                    reminder: t.reminderNumber,
                });

            });
        }
    }

    getZeitBisStart(termin: MainDataModels.Termin) {
        let result = '';
        let terminStunde: number = Number(termin.startTime?.substring(0, 2));
        let terminMinute: number = Number(termin.startTime?.substring(3, 5));
        if (terminStunde >= this.aktuelleUhrzeitStunden) {
            // Stunden sind gleich
            if (terminStunde === this.aktuelleUhrzeitStunden) {
                if (terminMinute > this.aktuelleUhrzeitMinuten) {
                    //Die Minuten sind grösser als die aktuelle
                    result =
                        'in ' + (terminMinute - this.aktuelleUhrzeitMinuten) + ' Min.';
                }
            } else {
                // Stunden sind nicht gleich
                if (terminMinute >= this.aktuelleUhrzeitMinuten) {
                    result =
                        'in ' +
                        (terminStunde - this.aktuelleUhrzeitStunden) +
                        'Std. ' +
                        (terminMinute - this.aktuelleUhrzeitMinuten) +
                        ' Min.';
                } else {
                    if (terminStunde - this.aktuelleUhrzeitStunden - 1 === 0) {
                        result =
                            'in ' +
                            (terminMinute + (60 - this.aktuelleUhrzeitMinuten)) +
                            ' Min.';
                    } else {
                        result =
                            'in ' +
                            (terminStunde - this.aktuelleUhrzeitStunden - 1) +
                            'Std. ' +
                            (terminMinute + (60 - this.aktuelleUhrzeitMinuten)) +
                            ' Min.';
                    }
                }
            }
        }
        return result;
    }

    showDetails(eintrag: TerminEintrag) {
        this.svcMainData.loadTerminByID(eintrag.id).subscribe({
            next: (res) => {
                this.dataForCalendarAppointment = res;

                this.dialog.open(MeineTermineDetailViewComponent, {
                    disableClose: true,
                    width: '800px',
                    data: this.dataForCalendarAppointment,
                });
            },
        });
    }

    showTerminDetail(eintrag: TerminEintrag) {
        // Termin für das "Wieder-Laden" beim App-Start in IndexedDB speichern
        this.svcMainData.saveChoosedAppointmentToDB(eintrag.id);

        this.svcMainData.loadTerminByID(eintrag.id).subscribe({
            next: (res) => {
                this.dataForCalendarAppointment = res;

                var dialogRef = this.dialog.open(TerminEintragComponent, {
                    disableClose: true,
                    width: '800px',
                    data: this.dataForCalendarAppointment,
                });

                dialogRef.afterClosed().subscribe({
                    next: (result) => {
                        this.currTerminMitBenutzern = result;
                        if (this.currTerminMitBenutzern) {
                            // Update Informations
                            this.svcMainData
                                .saveTermin(this.currTerminMitBenutzern)
                                .subscribe({
                                    next: (res) => {
                                        this.svcMessageBox.showSuccess(
                                            'Der Termin wurde erfolgreich aktualisiert.',
                                            'Erfolgreich'
                                        );
                                        this.svcMainData.reloadCalendarData();
                                        this.loadTermine();
                                    },
                                    error: (error) => {
                                        console.log(error);
                                        this.svcMessageBox.showError(
                                            'Der Termin konnte nicht angepasst werden!!',
                                            '!! FEHLER !!'
                                        );
                                    },
                                });
                            if (this.swissSettings.getWebConfig().debugMode) {
                                console.log(
                                    'Dialog Resultat (currTerminMitBenutzern): ',
                                    this.currTerminMitBenutzern
                                );
                            }
                        }
                    },
                });
            },
        });
    }

    private loadTermine() {
        // Pendenzen Live vom Webservice holen
        this.svcMainData.getUserTermine().subscribe({
            next: (res) => {
                this.dbTermine = res;
                this.loadListenTermine();
            },
            error: (err) => {
                // Webservice nicht verfügbar --> aus IndexedDB laden
                this.loadTermineFromIndexedDB();
            },
        });
    }
}
